import {GetAPIBaseURLByService} from "../util/http/API";

export const GrayLogUrl = (): string => {
    return GetAPIBaseURLByService("logging/v1/");
};
